module.exports = __webpack_public_path__ + "static/diritto-penale-9c76dc9c8a3734c1f71c1c2f37f78e0f.png";